export default __webpack_public_path__ + "9c819ae32df91ee7338a625413283731.svg";